import {reject} from "q";
import {HttpError} from "./HttpError";

export default async function toDataURL(imageUrl: string): Promise<string> {
    let response = await fetch(imageUrl);
    if (!response.ok) {
        throw new HttpError("Unable to download image", {
            url: imageUrl
        });
    }

    const blob = await response.blob();

    return await new Promise(resolve => {
        const reader = new FileReader();

        reader.onload = () => resolve(reader.result as any);
        reader.onerror = () => reject("Unable to download image");

        reader.readAsDataURL(blob);
    });
}